import React from 'react';
import { motion } from 'framer-motion';
import { useProfile } from './hooks/useProfile';
import { ProfileHeader } from './components/ProfileHeader';
import { ProfileSidebar } from './components/ProfileSidebar';
import { ProfileTabs } from './components/ProfileTabs';

export function Profile() {
  const {
    user,
    activeTab,
    setActiveTab,
    name,
    setName,
    orgName,
    setOrgName,
    currentPassword,
    setCurrentPassword,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    showCurrentPassword,
    setShowCurrentPassword,
    showNewPassword,
    setShowNewPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    showPasswordErrors,
    isUpdating,
    isOrgAdmin,
    checks,
    handleUpdateInfo,
    handleUpdatePassword,
    joinedDate
  } = useProfile();

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      style={{
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxSizing: 'border-box'
      }}
    >
      {/* ── Page Header ── */}
      <ProfileHeader />

      {/* ── Main Layout Grid ── */}
      <div className="grid grid-cols-12 gap-5" style={{ width: '100%', boxSizing: 'border-box' }}>
        {/* Left Sidebar Card */}
        <div className="col-span-12 md:col-span-4">
          <ProfileSidebar user={user} joinedDate={joinedDate} />
        </div>

        {/* Right Side Tabs */}
        <div className="col-span-12 md:col-span-8">
          <ProfileTabs
            user={user}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            name={name}
            setName={setName}
            orgName={orgName}
            setOrgName={setOrgName}
            currentPassword={currentPassword}
            setCurrentPassword={setCurrentPassword}
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            showCurrentPassword={showCurrentPassword}
            setShowCurrentPassword={setShowCurrentPassword}
            showNewPassword={showNewPassword}
            setShowNewPassword={setShowNewPassword}
            showConfirmPassword={showConfirmPassword}
            setShowConfirmPassword={setShowConfirmPassword}
            showPasswordErrors={showPasswordErrors}
            isUpdating={isUpdating}
            isOrgAdmin={isOrgAdmin}
            checks={checks}
            handleUpdateInfo={handleUpdateInfo}
            handleUpdatePassword={handleUpdatePassword}
          />
        </div>
      </div>
    </motion.div>
  );
}
